var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.checkWidth() + ' ' + 'container'},[(_vm.loading)?[_c('div',{staticClass:"container vertical-center"},[_c('LoadingMDL')],1)]:[_c('CardContent',{attrs:{"cardContent":_vm.content,"cardTypeProps":_vm.cardTypeProps,"soundOBJ":_vm.soundObject},on:{"nextRoute":_vm.nextRoute}})]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }